export class Expedientes_Detalle_InformacionGeneral_DTO {
    idAliado: number;
    id: number;
    identificacion: string;
    nombre: string;
    apellido: string;
    celular: string;
    fijo: string;
    departamento: string;
    ciudad: string;
    direccion: string;
    nombreContacto: string;
    apellidoContacto: string;
    eventosIncluidos: number;
    eventosDisponibles: number;
    expedientesabiertos: number;
    montoMaximoCobertura: string;
    ocurrido: string;
    codigoEstado: string;
    estado: string;
    fechaCreacion: Date;
    tipo: string;
    idCanal: number;
    canal: string;
    cliente: string;
    idProducto: number;
    producto: string;
    programa: string;
    servicio: string;
    subServicio: string;
    cola: string;
    priopetario: string;
    responsable: string;
}